module.exports = __webpack_public_path__ + "img/left2Left1.03fb3433.png";